import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { SchemesQuery as SchemesQueryType, SchemesQueryVariables } from "./__generated__/SchemesQuery";

const SchemesQuery = loader("./SchemesQuery.gql");

type SchemesQueryProviderType = (props: {
  children: (data: SchemesQueryType) => ReactNode;
  variables?: SchemesQueryVariables;
}) => ReactElement;

export const SchemesQueryProvider: SchemesQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<SchemesQueryType, SchemesQueryVariables>(SchemesQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
